import { useQuery } from 'react-query';
import { SearchConversationsCount } from 'v2/models';
import restFactory from 'v2/utils/restFactory';

export function getKey(searchId: number) {
  return ['Get conversations count by request id', searchId];
}

export function useSearchConversationCount(searchId: number) {
  return useQuery(getKey(searchId), () =>
    restFactory.get<SearchConversationsCount>(
      `/dj/api/v1/conversations/get_conversations_count_from_search_id/`,
      { search_id: searchId }
    )
  );
}
